// extracted by mini-css-extract-plugin
export default {"changeLink":"LQ-z","disabled":"MQ-z","inline":"NQ-z"};